import { render, staticRenderFns } from "./SlideDown.vue?vue&type=template&id=24ed0cf5"
import script from "./SlideDown.vue?vue&type=script&lang=js"
export * from "./SlideDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports